import { render, staticRenderFns } from "./CommutatorReferenceField.vue?vue&type=template&id=1a1a09f5&scoped=true&"
import script from "./CommutatorReferenceField.vue?vue&type=script&lang=js&"
export * from "./CommutatorReferenceField.vue?vue&type=script&lang=js&"
import style0 from "./CommutatorReferenceField.vue?vue&type=style&index=0&id=1a1a09f5&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1a09f5",
  null
  
)

export default component.exports